import singletonSession from '@src/sagas/singletonSession';
import { all, spawn } from 'redux-saga/effects';
import adsSaga from './ads';
import allBotAccounts from './allBotAccounts';
import assistantSaga from './assistants';
import auditUsersSaga from './auditUsers';
import automaticMessages from './automaticMessages';
import botAccounts from './botAccounts';
import businessTime from './businessTime';
import callConsumptionReport from './callConsumptionReport';
import carouselImagesSaga from './carouselImages';
import channels from './channels';
import chatAutoAssignment from './chatAutoAssignment';
// eslint-disable-next-line import/no-cycle
import chatHistory from './chatHistory'; // TODO: fix circular dependency from agentchatmanager
import chatMessageQueueSaga from './chatMessageQueue';
import chats from './chats';
import chatsBehavior from './chatsBehavior';
import chatSearch from './chatSearch';
import chatTransfer from './chatTransfer';
import chatViewerSaga from './chatViewer';
import consoleGeneralSettingsSaga from './consoleGeneralSettings';
import consoleWidgets from './consoleWidgets';
import contact from './contact';
import contactsImport from './contactsImport';
import countriesSaga from './countries';
import deliveriesMassiveSaga from './deliveriesMassive';
import departmentsSaga from './departments';
import integrationHubspotSaga from './integrationHubspot';
import integrationsSaga from './integrations';
import merchantPlanUsage from './merchantPlanUsage';
import quickMessageSaga from './quickMessage';
import requestSpecialAccount from './requestSpecialAccount';
import shopifySaga from './shopifySaga';
import standardMessages from './standardMessage';
import tags from './tags';
import periodicReconcile from './periodicReconcile';
import uniqueContactsReportSaga from './uniqueContactsReport';
import uploadFiles from './uploadFiles';
import urlPreview from './urlPreview';
import userActivity from './userActivity';
import usersSaga from './users';
import user from './userState';
import UserStatusSaga from './userStatus';
import userWaAccounts from './userWaAccounts';
import websocketSaga from './websocket';
import whatsAppProfile from './whatsAppProfile';
import whatsAppTemplates from './whatsAppTemplates';
import whatsAppValidateExcelSaga from './whatsAppValidateExcel';
import whatsAppSendBroadcastSaga from './whatsAppSendBroadcast.saga';
import wsCatalogue from './wsCatalogue';
import wsConversationReportSaga from './wsConversationReport';
import wsFlowEditorSaga from './wsFlowEditor';
import wsFlows from './wsFlows';

function* rootSaga() {
  yield spawn(singletonSession);
  yield spawn(websocketSaga);

  yield all([
    //TODO: TEMPOPORAL
    // singletonSession(),
    // websocketSaga(),
    userWaAccounts(),
    contactsImport(),
    departmentsSaga(),
    standardMessages(),
    uploadFiles(),
    chatSearch(),
    chatAutoAssignment(),
    urlPreview(),
    user(),
    usersSaga(),
    quickMessageSaga(),
    chatMessageQueueSaga(),
    automaticMessages(),
    chatTransfer(),
    botAccounts(),
    merchantPlanUsage(),
    whatsAppProfile(),
    whatsAppTemplates(),
    whatsAppValidateExcelSaga(),
    whatsAppSendBroadcastSaga(),
    requestSpecialAccount(),
    deliveriesMassiveSaga(),
    chatHistory(),
    chats(),
    shopifySaga(),
    adsSaga(),
    consoleWidgets(),
    contact(),
    countriesSaga(),
    wsConversationReportSaga(),
    integrationsSaga(),
    wsCatalogue(),
    chatsBehavior(),
    auditUsersSaga(),
    tags(),
    chatViewerSaga(),
    wsFlows(),
    wsFlowEditorSaga(),
    assistantSaga(),
    carouselImagesSaga(),
    integrationHubspotSaga(),
    userActivity(),
    UserStatusSaga(),
    allBotAccounts(),
    channels(),
    businessTime(),
    uniqueContactsReportSaga(),
    consoleGeneralSettingsSaga(),
    callConsumptionReport(),
    periodicReconcile(),
  ]);
}

export default rootSaga;
